// Blog verisi önbelleği: bir kez alınan sayfa tekrar istenmez, geçişler anında olur.
// Doğrudan açılan statik sayfada veri <script id="tivigo-blog-data"> içinde gelir; BlogPage onu buraya yazar.
const pages = new Map();
const pending = new Map();

const keyOf = (slug) => slug || '';

export const getCachedBlogPage = (slug) => pages.get(keyOf(slug)) || null;

export const primeBlogPage = (page) => {
  if (page) pages.set(keyOf(page.slug), page);
};

export function loadBlogPage(slug) {
  const key = keyOf(slug);
  if (pages.has(key)) return Promise.resolve(pages.get(key));
  if (!pending.has(key)) {
    pending.set(key, fetch(`/blog-data/${key ? encodeURIComponent(key) : 'index'}.json`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status === 404 ? 'Bu yazı bulunamadı.' : 'Blog şu anda yüklenemiyor.');
        return response.json();
      })
      .then((data) => {
        pages.set(key, data);
        pending.delete(key);
        return data;
      })
      .catch((error) => {
        pending.delete(key);
        throw error;
      }));
  }
  return pending.get(key);
}

// Ana sayfadayken bloğun liste verisini boş zamanda indirir; Blog'a geçiş beklemeden açılır.
export function prefetchBlog() {
  const run = () => { loadBlogPage('').catch(() => {}); };
  if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(run, { timeout: 4000 });
  else window.setTimeout(run, 1500);
}
